import { PageKey } from '~/constants/page';
import { apiAuthFeiShu } from '~/utils/feishu';

export default defineNuxtPlugin(() => {
  const route = useRoute();
  if (import.meta.client && route.name === PageKey.HOME) {
    let retryTimer: ReturnType<typeof setTimeout> | null = null;
    let retryCount = 0;
    const MAX_RETRIES = 10; // 最多重试 10 次（5秒）

    // 延迟检查 h5sdk（避免异步加载未完成）
    const checkH5sdk = () => {
      if (window.h5sdk) {
        // 替换 alert 为日志输出
        apiAuthFeiShu();
        // 清理定时器
        if (retryTimer) {
          clearTimeout(retryTimer);
          retryTimer = null;
        }
      } else {
        retryCount++;
        // 重试机制（假设 h5sdk 可能异步加载，最多等待5秒）
        if (retryCount < MAX_RETRIES) {
          retryTimer = setTimeout(checkH5sdk, 500);
        } else {
          // 达到最大重试次数，清理定时器
          retryTimer = null;
        }
      }
    };
    checkH5sdk();

    // 在路由离开时清理定时器，避免内存泄露
    // 注意：Nuxt 插件通常不需要手动清理，但为了安全起见，我们提供清理机制
    if (typeof window !== 'undefined') {
      window.addEventListener('beforeunload', () => {
        if (retryTimer) {
          clearTimeout(retryTimer);
          retryTimer = null;
        }
      });
    }
  }
});
